import { isChild } from '@apia/util';
import { DragAndDrop } from '../util/DragAndDrop';

export function dragleave(_ev: Event, DragAndDrop: DragAndDrop) {
  const ev = _ev as DragEvent;

  if (
    ev.relatedTarget === null ||
    isChild(ev.relatedTarget as HTMLElement, (current) => {
      return (
        current.parentElement === null &&
        current === document.getRootNode() &&
        current.dataset.splash === undefined
      );
    })
  ) {
    const shadows = document.querySelectorAll('.apia_panel_falseDiv');

    shadows.forEach((el) => el.remove());
    DragAndDrop.draggingPanel?.setAttribute('style', '');
  }
}
